import { Skeleton } from "../ui/skeleton";

export const PrimaryPropertyDetailsSkeleton = () => {
  return (
    <div
      className="min-h-screen bg-background"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading property details"
    >
      <main className="pt-4 sm:pt-6 md:pt-8 lg:pt-10 pb-12 sm:pb-16 lg:pb-24">
        <div className="container mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            <div className="lg:col-span-2 space-y-4 sm:space-y-6 md:space-y-8">
              <div className="relative rounded-xl sm:rounded-2xl overflow-hidden aspect-video">
                <Skeleton className="absolute inset-0 rounded-none" />
                <div className="absolute top-4 left-4 flex gap-2">
                  <Skeleton className="h-7 w-16 rounded-full" />
                  <Skeleton className="h-7 w-24 rounded-full" />
                </div>
                <div className="absolute bottom-6 left-6 space-y-2">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-8 w-64 sm:w-80" />
                </div>
              </div>

              <div className="grid grid-cols-4 gap-4">
                {[0, 1, 2, 3].map((key) => (
                  <Skeleton key={key} className="aspect-square rounded-lg" />
                ))}
              </div>

              <div className="space-y-6">
                <div className="bg-card border border-white/[0.07] p-1 rounded-lg flex flex-wrap gap-1 w-fit">
                  {[0, 1, 2, 3].map((key) => (
                    <Skeleton key={key} className="h-9 w-24 rounded-md" />
                  ))}
                </div>
                <div className="p-6 rounded-2xl bg-card border border-white/[0.07] space-y-4">
                  <Skeleton className="h-6 w-56" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-5/6" />
                  <Skeleton className="h-4 w-2/3" />
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[0, 1, 2, 3].map((key) => (
                    <div
                      key={key}
                      className="p-4 rounded-xl bg-card border border-white/[0.07] text-center space-y-2"
                    >
                      <Skeleton className="h-5 w-5 mx-auto rounded-full" />
                      <Skeleton className="h-6 w-16 mx-auto" />
                      <Skeleton className="h-3 w-20 mx-auto" />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="lg:col-span-1 order-first lg:order-last">
              <div className="lg:sticky lg:top-36 p-4 sm:p-5 md:p-6 rounded-xl sm:rounded-2xl bg-card border border-white/[0.07] shadow-card">
                <div className="flex items-center justify-between mb-4">
                  <Skeleton className="h-6 w-40" />
                  <Skeleton className="h-6 w-16 rounded-full" />
                </div>
                <div className="space-y-3 mb-4">
                  {[0, 1, 2, 3].map((key) => (
                    <div
                      key={key}
                      className="flex justify-between py-2 border-b border-white/[0.07]"
                    >
                      <Skeleton className="h-4 w-28" />
                      <Skeleton className="h-4 w-16" />
                    </div>
                  ))}
                </div>
                <div className="mb-4 space-y-2">
                  <div className="flex justify-between">
                    <Skeleton className="h-4 w-32" />
                    <Skeleton className="h-4 w-10" />
                  </div>
                  <Skeleton className="h-2.5 w-full rounded-full" />
                  <div className="flex justify-between">
                    <Skeleton className="h-3 w-16" />
                    <Skeleton className="h-3 w-16" />
                  </div>
                </div>
                <Skeleton className="h-12 w-full rounded-xl mb-3" />
                <Skeleton className="h-10 w-full rounded-xl" />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
